import { getConfig } from "@/get-config";
const { cdnAssetUrl } = getConfig();
const PromotionBanner = () => (
  <section className="w-full">
    <div className="flex justify-center items-center pb-12 px-4 md:px-6">
      <img
        className="self-center"
        src={`${cdnAssetUrl}promotionBanner.webp`}
        alt="Banner Image"
      />
    </div>
  </section>
);

export default PromotionBanner;
